import React, { FC } from 'react';
import { OnBoardingFooterStyled, OnBoardingToolbarStyled } from './OnBoardingFooter.style';
import { Container } from '@mindly/ui-components';

type OnBoardingFooterProps = {
  children?: React.ReactNode;
  isAnalyse?: boolean;
  isPopup?: boolean;
};

const OnBoardingFooter: FC<OnBoardingFooterProps> = ({ children, isAnalyse = false, isPopup = false }) => {
  return (
    <OnBoardingFooterStyled>
      <OnBoardingToolbarStyled isPopup={isPopup}>
        <Container style={isAnalyse ? { padding: 0 } : { paddingTop: 0 }}>{children}</Container>
      </OnBoardingToolbarStyled>
    </OnBoardingFooterStyled>
  );
};

export default React.memo(OnBoardingFooter);
